import { render, staticRenderFns } from "./TabulacaoReports.vue?vue&type=template&id=0b0f064c&"
import script from "./TabulacaoReports.vue?vue&type=script&lang=js&"
export * from "./TabulacaoReports.vue?vue&type=script&lang=js&"
import style0 from "./TabulacaoReports.vue?vue&type=style&index=0&id=0b0f064c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports